interface PageMetaProps {
  title: string;
  description: string;
  keywords?: string;
  canonicalPath?: string;
  ogType?: string;
  ogImage?: string;
}

export default function PageMeta({
  title,
  description,
  keywords,
  canonicalPath,
  ogType = "website",
  ogImage,
}: PageMetaProps) {
  const siteUrl = import.meta.env.VITE_SITE_URL || "https://usfansspreadsheet.help";
  const canonical = canonicalPath ? `${siteUrl}${canonicalPath}` : siteUrl;
  const fullTitle = canonicalPath ? `${title} | USFansSpreadsheet.help` : title;

  return (
    <>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      <meta name="robots" content="index, follow" />
      <link rel="canonical" href={canonical} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:type" content={ogType} />
      {ogImage && <meta property="og:image" content={ogImage} />}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      {ogImage && <meta name="twitter:image" content={ogImage} />}
    </>
  );
}